/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { iconGetIcon } from '../fn/icon/icon-get-icon';
import { IconGetIcon$Params } from '../fn/icon/icon-get-icon';

@Injectable({ providedIn: 'root' })
export class IconService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `iconGetIcon()` */
  static readonly IconGetIconPath = '/icon/{iconId}';

  /**
   * Returns the requested icon.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `iconGetIcon()` instead.
   *
   * This method doesn't expect any request body.
   */
  iconGetIcon$Response(params: IconGetIcon$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    const obs = iconGetIcon(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Returns the requested icon.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `iconGetIcon$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  iconGetIcon(params: IconGetIcon$Params, context?: HttpContext): Observable<Blob> {
    const resp = this.iconGetIcon$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
